import { Style, Fill, Stroke } from 'ol/style';

// import { WgisService } from './wgis.service';
import { WGisServiceInterface, WGisFeatureInfo, WGisFeatureInterface } from './wgis.utils';
import { WGisFeature } from './wgis.feature';

import Feature from 'ol/Feature';
import WKT from 'ol/format/WKT';
import { WGisEngine } from './wgis.engine';
import { FieldsInterface, MapEngineOptions, BaseEngine } from './wgis.utils';
import * as _ from 'lodash';

export abstract class WGisSelectableEngine extends WGisEngine implements BaseEngine {
  format: WKT;
  defaultstyle: Style;
  // param Object options

  constructor(options: MapEngineOptions, wgisService: WGisServiceInterface) {
    super(options, wgisService);
    this.format = new WKT();
  }

  // crea una feature a aggiunge istanza di OikosMngmt  con proprieta da overide
  buildFeature(geometry: string, attribute: FieldsInterface, info: WGisFeatureInfo): WGisFeatureInterface {
    const feature = this.feature_factory(attribute, geometry);
    info.engineName = this.name;
    feature.setWgisInfo(info);
    return feature;
  }

  feature_factory(fields: FieldsInterface, wkt: string, projection: string = 'EPSG:4326'): WGisFeatureInterface {
    const feature = new WGisFeature(fields);
    if ( (wkt !== undefined ) && (wkt !== null ) && (wkt !== '' ) ){
      feature.setGeometry(this.format.readGeometry(
        wkt,
        {
          dataProjection: projection,
          featureProjection: this.service.config.view.projection
        }));
    }
    return feature;
  }
  /**
   * imposta un stile come pedefinito
   * @param style Stile da impostare
   */
  setDefaultStyle(style: Style): void {
    this.defaultstyle = style;
  }


  selectByAny(geometry: string, obj: any, projection: string = 'EPSG:4326'): WGisFeatureInterface {
    const feature: WGisFeatureInterface = this.feature_factory(WGisEngine.extract_fileds(obj), geometry);
    if (this.defaultstyle) {
      feature.setStyle(this.defaultstyle);
    }
    this.addFeatureToSelection(feature);
    return feature;
  }


  // OVERIDE ME
  abstract clearSelection(): void;
  abstract getSelection(): void;
  abstract addFeatureToSelection(feature: Feature);
  abstract removeFeatureFromSelection(feature: Feature);
}
